export const NEW_QUESTION_ID_PARAM = 'new';
export const SYLLABUS_SLUG_PARAM = 'syllabusSlug';

export enum CmsUrlParts {
  // General
  Overview = 'overview',

  // Payment
  PaymentRequests = 'payment-requests',
  BonusStructure = 'bonus-structure',

  // Analytics
  ContentAnalytics = 'content-analytics',
  UserAnalytics = 'user-analytics',

  // Utility
  PreviewFromJson = 'preview-from-json', // Will be shown as "JSON Viewer" in UI

  Playground = 'playground',

  // nested playground
  SuperLatex = 'super-latex',
  Solver = 'solver',
  QuadraticFunctions = 'quadratic-functions',
  Graph = 'graph',
  Ontology = 'ontology',
  StudyNotesEditor = 'study-notes-editor',

  // Sub-sections
  Questions = 'questions',
  ReferenceQuestions = 'reference-questions',
  GenerateQuestions = 'generate-questions',
  Syllabus = 'syllabus',
  Sources = 'sources',
  NoAccess = 'no-access',
  Admin = 'admin',
  Profile = 'profile',
}
